import React from "react";
import cn from "classnames";
import { InlineFlexBox } from "../../../Components";
import "./Item.scss";
import styles from "./Item.module.scss";

const isMissingPrice = (hasPrice, isDisabled) =>
  !isDisabled && !hasPrice ? styles.missingPrice : "";

export const Item = ({ children, hasPrice, isDisabled }) => (
  <InlineFlexBox
    flexDirection="column"
    alignItems="center"
    className={cn(styles.item, isMissingPrice(hasPrice, isDisabled))}
  >
    {children}
  </InlineFlexBox>
);

export const HeaderItem = ({ children }) => (
  <InlineFlexBox className={cn(styles.item)}>{children}</InlineFlexBox>
);
